import { useMemo } from 'react';
import { useQueryDefinition } from '@intelligence/hooks/useQueryDefinition';

interface ISteamNewsOptions {
  value: string;
  label: string;
  label_cn?: string;
}

/**
 * 根据当前语言展示 SteamNews 的 Segment 配置项
 *
 * @param {boolean} isCN 是否为中文
 * @returns {{ localeSegmentOptions: ISteamNewsOptions; excludeEventType: string[]; }} segment 选项、选中 others 时需排除的 eventType
 */
function useLocaleSegmentOptions(isCN: boolean) {
  // 获取 steam_news_types 配置
  const steamNewsOptionsConfig: ISteamNewsOptions[] = useQueryDefinition('steam_news_types', []);

  const localeSegmentOptions = useMemo(() => {
    const options = [
      {
        value: 'all',
        label: 'All',
        label_cn: '全部',
      },
      // 从公共配置中获取
      ...(steamNewsOptionsConfig || []),
      {
        value: 'others',
        label: 'Others',
        label_cn: '其他',
      },
    ];

    return options?.map((item) => {
      return {
        ...item,
        text: (isCN ? item.label_cn : item.label) || item.label,
      };
    });
  }, [steamNewsOptionsConfig, isCN]);

  // 选择 Others 时，需要将固定配置作为排除参数
  const excludeEventType = steamNewsOptionsConfig?.map((item) => item.value);

  return { localeSegmentOptions, excludeEventType };
}

export default useLocaleSegmentOptions;
